angular.module('mercury.modules.stock.positemlink', []);
